import { useInternalFeatureFlags } from "./useInternalFeatureFlags";

/**
 * Hook to determine when feature flags are ready to be used.
 * This prevents premature redirects based on feature flag values
 * that haven't been loaded yet.
 *
 * Returns true when internal feature flags have been fetched from the backend.
 */
export const useFeatureFlagsReady = (): boolean => {
  const { isFetched } = useInternalFeatureFlags();
  return isFetched;
};
